import "./ProductList.scss";

import React from "react";
import { Link } from "react-router-dom";
import usesFeatures from "usesFeatures"
import request from "request"
import User from "User"

import Header from "Header"

class ProductList extends React.Component {
  state = {
    dragCategoryId: null,
    dragIndex: null,
    dragOverIndex: null,
    downloading: false,
  }

  componentDidMount() {
    this.props.fetchData("/venue_admin/products")
  }

  productsFor = (categoryId) => {
    return this.props.products.filter((p) => p.categoryId == categoryId)
  }

  onDragStart = (categoryId, index) => {
    this.setState({ dragCategoryId: categoryId, dragIndex: index })
  }

  onDragOver = (categoryId, index, e) => {
    e.preventDefault()
    if (this.state.dragCategoryId !== categoryId) return
    if (this.state.dragOverIndex !== index) {
      this.setState({ dragOverIndex: index })
    }
  }

  onDragEnd = () => {
    this.setState({ dragCategoryId: null, dragIndex: null, dragOverIndex: null })
  }

  onDrop = (categoryId, dropIndex) => {
    const { dragCategoryId, dragIndex } = this.state
    const products = this.productsFor(categoryId)

    this.setState({ dragCategoryId: null, dragIndex: null, dragOverIndex: null })

    if (dragCategoryId !== categoryId || dragIndex === null || dragIndex === dropIndex) return

    const reordered = [...products]
    const [moved] = reordered.splice(dragIndex, 1)
    reordered.splice(dropIndex, 0, moved)

    request.post("/venue_admin/products/reorder", { order: reordered.map(p => p.id) })
      .then(() => this.props.fetchData("/venue_admin/products"))
  }

  handleDownload = () => {
    this.setState({ downloading: true })

    const authToken = User.getAuthToken()
    const csrfToken = document.getElementsByName("csrf-token")[0].content

    const xhr = new XMLHttpRequest()
    xhr.open("POST", "/api/venue_admin/products/download", true)
    xhr.setRequestHeader("Authorization", authToken)
    xhr.setRequestHeader("X-CSRF-Token", csrfToken)
    xhr.setRequestHeader("X-CURRENT-PAGE", window.location.href)
    xhr.responseType = "blob"

    xhr.onload = () => {
      this.setState({ downloading: false })
      if (xhr.status === 200) {
        const downloadUrl = window.URL.createObjectURL(xhr.response)
        const link = document.createElement("a")
        link.href = downloadUrl
        link.download = `Products - ${new Date().toISOString().split("T")[0]}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)
      } else {
        console.error("Download failed with status:", xhr.status)
      }
    }

    xhr.onerror = () => {
      this.setState({ downloading: false })
      console.error("XHR error occurred")
    }

    xhr.send()
  }

  renderProductRows = (category) => {
    const products = this.productsFor(category.simpleId)
    const { externalMenus } = this.props
    const { dragCategoryId, dragIndex, dragOverIndex } = this.state

    if (products.length === 0) {
      return (
        <tr>
          <td colSpan={externalMenus ? 2 : 4} className="is-italic has-text-centered">
            No Products Found. Time to <Link to={`/products/new?categoryId=${category.simpleId}`}>create one</Link>?
          </td>
        </tr>
      )
    }

    return products.map((product, index) => {
      const isDragOver = dragCategoryId === category.simpleId && dragOverIndex === index && dragIndex !== index
      return (
        <tr
          key={product.id}
          draggable={!externalMenus}
          onDragStart={() => this.onDragStart(category.simpleId, index)}
          onDragOver={(e) => this.onDragOver(category.simpleId, index, e)}
          onDrop={() => this.onDrop(category.simpleId, index)}
          onDragEnd={this.onDragEnd}
          className={isDragOver ? "drag-over" : ""}
        >
          { !externalMenus &&
            <td className="drag-handle-col">
              <span className="drag-handle" title="Drag to reorder">
                <i className="fas fa-grip-vertical"></i>
              </span>
            </td>
          }
          <td><Link to={`/products/${product.id}`}>{product.name}</Link></td>
          <td className="is-narrow pr-4">${product.price}</td>
          { !externalMenus &&
            <td className="is-narrow"><Link to={`/products/${product.id}/edit`}>Edit</Link></td>
          }
        </tr>
      )
    })
  }

  render() {
    if (!this.props.dataFetched) return false

    const { categories, externalMenus } = this.props
    return(
      <div className="ProductList">
        <Header
          text="Products"
          actions={true}
        >
          <button
            className="button mr-2"
            onClick={this.handleDownload}
            disabled={this.state.downloading}
          >
            {this.state.downloading ? "Downloading..." : "Download CSV"}
          </button>
          <Link to="/products/new" className="button is-primary">New Product</Link>
        </Header>
        { categories.map((c) => (
          <div key={c.id} className="block">
            <h3 className="title">{ c.name }</h3>
            <div className="Table block">
              <div className="table-wrapper">
                <table className="table is-fullwidth is-datatable">
                  <thead>
                    <tr className="has-text-left">
                      { !externalMenus && <th className="drag-handle-col"></th> }
                      <th>Product Name</th>
                      <th>Price</th>
                      { !externalMenus && <th></th> }
                    </tr>
                  </thead>
                  <tbody>
                    { this.renderProductRows(c) }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default usesFeatures(["data"], ProductList)
